<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <v-layout align-center justify-center column pb-2>
          <h2 class="heading-3">Register with email</h2>
        </v-layout>

        <v-alert
          :value="true"
          v-if="error != null"
          type="error"
          v-html="error.message"
        ></v-alert>

        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" @submit="signUp">
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="firstName"
                  :rules="firstNameRules"
                  label="First Name *"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="lastName"
                  :rules="lastNameRules"
                  label="Last Name *"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="username"
                  :rules="usernameRules"
                  type="email"
                  label="Email Address *"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 sm2>Date of Birth*</v-flex>
              <v-flex xs12 sm3>
                <v-select
                  :items="days"
                  label="DD"
                  v-model="dobDay"
                  :rules="dobRules"
                  required
                  outline
                ></v-select>
              </v-flex>
              <v-flex xs12 sm3>
                <v-select
                  :items="months"
                  label="MM"
                  v-model="dobMonth"
                  :rules="dobRules"
                  outline
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4>
                <v-select
                  :items="years"
                  label="YYYY"
                  v-model="dobYear"
                  :rules="dobRules"
                  outline
                  required
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row v-show="this.parentalConsentRequired === true">
              <v-flex xs12 pb-0>
                <p>
                  You are under 13 years of age. Please ask your parent or
                  guardian to complete this registration for you. You should not
                  complete this registration yourself.
                </p>

                <p>
                  <strong>Note to parents / guardians:</strong> To create a
                  {{ configStrings.AltProductName }} for the child named above,
                  please complete the required information and provide your
                  consent below.
                </p>

                <p>
                  We recommend that you use an email address controlled by you
                  and not the email address of the child named above.
                </p>
              </v-flex>
            </v-layout>

            <v-layout row v-show="this.parentalConsentRequired === true">
              <v-flex xs12 pb-0>
                <v-switch
                  :label="
                    `I confirm that I am the parent/guardian of the child named above and consent to this ` +
                    configStrings.productName +
                    ` being created on their behalf.`
                  "
                  v-model="parentalConsentReceived"
                  :rules="parentalConsentReceivedRules"
                  color="#660033"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-select
                  outline
                  :items="countries"
                  v-model="country"
                  item-text="name"
                  :rules="countryRules"
                  label="Country*"
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  ref="pass"
                  v-model="pass"
                  :rules="passRules"
                  label="Password *"
                  type="password"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  outline
                  ref="passConfirm"
                  v-model="passConfirm"
                  :rules="passConfirmRules"
                  label="Confirm Password *"
                  type="password"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <p class="password-notice">
                  A valid password must contain one upper case letter, one lower
                  case letter, a number and a special character (e.g. ^ $ * . !
                  @ # % &amp;) and also must be at least 8 characters in length.
                </p>
              </v-flex>
            </v-layout>

            <v-layout row v-show="this.parentalConsentRequired === false">
              <v-flex xs12 pb-0>
                <strong>Club Email:</strong>
                <v-switch
                  :label="
                    `I want to receive emails from ` +
                    configStrings.clubName +
                    ` for the latest updates including Club News, Exclusive Member Updates, New Signings, Competitions, Offers and Ticket Availability.`
                  "
                  v-model="clubOptIn"
                  color="#660033"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-layout row v-show="this.parentalConsentRequired === false">
              <v-flex xs12 py-0>
                <strong>Partner Email:</strong>
                <v-switch
                  :label="`I want to receive emails from Official Club Partners (occasional offers and promotions)`"
                  v-model="partnerOptIn"
                  color="#660033"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-layout row v-show="this.parentalConsentRequired === false">
              <v-flex xs12>
                <p class="notice">
                  You can access our preference centre at any time to opt-out of
                  communications and control how we use your data.
                </p>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pt-0 pb-1>
                <v-switch
                  id="termsSwitch"
                  :label="`I have read and understood the Club's privacy policy`"
                  v-model="termsAgree"
                  :rules="termsAgreeRules"
                  color="#660033"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pt-0 pb-3>
                <p>
                  <a
                    class="privacy-policy text-button"
                    href="https://www.avfc.co.uk/club/legal/privacy-policy"
                    target="_blank"
                    >https://www.avfc.co.uk/club/legal/privacy-policy</a
                  >
                </p>
              </v-flex>
            </v-layout>

            <v-layout row align-center mx-1 py-0>
              <router-link to="/" class="text-button"
                >Already registered?</router-link
              >
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid">
                Register
              </button>
            </v-layout>
          </v-form>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "Registration",
  data() {
    return {
      valid: true,
      firstNameRules: [(v) => !!v || "First name is required"],
      lastNameRules: [(v) => !!v || "Last name is required"],
      countryRules: [(v) => !!v || "Country is required"],
      dobRules: [
        (v) => !!v || "Date of birth is required",
        (v) =>
          (
            this.dobYear +
            "-" +
            ("0" + this.dobMonth).slice(-2) +
            "-" +
            ("0" + this.dobYear).slice(-2)
          ).toString() < new Date().toISOString().split("T")[0] ||
          "Date can't be in the future",
      ],
      passRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 8) || "Password must be at least 8 characters",
        (v) =>
          /.*[a-z].*/.test(v) ||
          "Password must contain at least one lower case letter",
        (v) =>
          /.*[A-Z].*/.test(v) ||
          "Password must contain at least one upper case letter",
        (v) => /\d/.test(v) || "Password must contain at least one number",
        (v) =>
          /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(v) ||
          "Password must contain at least one special character (e.g. ^ $ * . ! @ # % &)",
        (v) =>
          (this.passConfirm.length >= 8 && v == this.passConfirm) ||
          "Password confirmation must match password",
      ],
      passConfirmRules: [
        (v) => v == this.pass || "Password confirmation must match password",
      ],
      usernameRules: [
        (v) => !!v || "Email address is required",
        (v) => /.+@.+/.test(v) || "Email must be valid",
        (v) =>
          !v.includes(" ") || "An email address can not contain any spaces",
      ],
      termsAgreeRules: [(v) => !!v || "You must agree to continue"],
      parentalConsentReceivedRules: [
        (v) =>
          this.configValues.accountConsentRequired === false ||
          this.age >= this.configValues.accountConsentAge ||
          (this.age < this.configValues.accountConsentAge && v === true) ||
          "You must have parental/guardian consent in order to continue",
      ],
      firstName: "",
      ssoid: "",
      lastName: "",
      username: "",
      pass: "",
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      clubOptIn: false,
      partnerOptIn: false,
      termsAgree: false,
      passConfirm: "",
      error: null,
      loading: false,
      parentalConsentRequired: false,
      parentalConsentReceived: false,
      age: null,
      countries: [],
      country: null,
      days: [],
      months: [],
      years: [],
    };
  },
  created() {
    this.populateDates();
    fetch("/countries.json")
      .then((r) => r.json())
      .then(
        (json) => {
          this.countries = json.countries;
        },
        (response) => {}
      );
  },
  watch: {
    pass: function (val, oldVal) {
      this.$refs.form.validate();
    },
    passConfirm: function (val, oldVal) {
      this.$refs.form.validate();
    },
    dobDay: function (val, oldVal) {
      this.checkForConsent();
      this.$refs.form.validate();
    },
    dobMonth: function (val, oldVal) {
      this.checkForConsent();
      this.$refs.form.validate();
    },
    dobYear: function (val, oldVal) {
      this.checkForConsent();
      this.$refs.form.validate();
    },
  },
  methods: {
    pad(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },

    checkForConsent() {
      if (this.configValues.accountConsentRequired === true) {
        //only check if this SSO requires age consent

        if (this.dobDay && this.dobMonth && this.dobYear) {
          // only check if we have a complete age in the form

          this.age = this.calculateAge(
            this.dobYear,
            this.dobMonth,
            this.dobDay
          ); // get age of the user based on the DoB fields

          if (this.age < this.configValues.accountConsentAge) {
            // if they are below the consent age then activate parental consent and opt out of marketing
            this.parentalConsentRequired = true;
            this.clubOptIn = false;
            this.partnerOptIn = false;
          } else {
            this.parentalConsentRequired = false;
          }

          this.$refs.form.validate();
        }
      }
    },
    populateDates() {
      for (var d = 1; d < 32; d++) {
        this.days.push(d);
      }
      for (var m = 1; m < 13; m++) {
        this.months.push(m);
      }
      var thisYear = new Date().getFullYear();
      for (var y = thisYear + 1; y > 1900; y--) {
        this.years.push(y);
      }
    },
    crmXCMPush(username) {
      var crmXCMPushURL =
        process.env.VUE_APP_XCM_CRM_API + "/user/push/" + username;

      return axios({
        method: "get",
        url: crmXCMPushURL,
      });
    },
    crmPush(username) {
      var vm = this;
      Promise.all([vm.crmXCMPush(username)]).then(function (results) {
        if (vm.$router.currentRoute.name === "app-register") {
          vm.$router.push("/app-post-registration-message");
        } else {
          vm.$router.push("/post-registration-message");
        }
      });
    },
    signUp(e) {
      e.preventDefault();
      this.loading = true;
      var email = this.username.toLowerCase();
      var password = this.pass;
      var firstName = this.firstName;
      var lastName = this.lastName;
      var termsAgree = this.termsAgree.toString();

      var attributesList = {
        given_name: firstName,
        family_name: lastName,
        "custom:privacy_accepted": termsAgree,
      };

      var address = {
        country: this.country,
      };
      attributesList["address"] = JSON.stringify(address);

      if (this.parentalConsentReceived.toString() === "true") {
        attributesList["custom:parental_consent"] = "true";
        var consentDate = new Date();
        attributesList["custom:parental_timestamp"] = consentDate.toISOString();
      }

      if (this.clubOptIn.toString() === "true") {
        attributesList["custom:club_email"] = "true";
      } else {
        attributesList["custom:club_email"] = "false";
      }

      if (this.partnerOptIn.toString() === "true") {
        attributesList["custom:partner_email"] = "true";
      } else {
        attributesList["custom:partner_email"] = "false";
      }

      if (this.dobDay && this.dobMonth && this.dobYear) {
        attributesList["birthdate"] =
          this.dobYear +
          "-" +
          this.pad(this.dobMonth, 2) +
          "-" +
          this.pad(this.dobDay, 2);
      }
      var vm = this;
      this.$signUp(email, password, attributesList).subscribe(
        (data) => {
          var username = data.user.username;
          vm.crmPush(username);
        },
        (err) => {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito

          if (
            err.message === "An account with the given email already exists."
          ) {
            err.message =
              "This is an existing " +
              this.configStrings.productName +
              " / Villa " +
              this.configStrings.productName +
              ' - <a href="/forgot-password" class="text-button--login-error">Please click here to reset your password</a>';
          }
          vm.error = err;
        }
      );
    },
  },
};
</script>

<style>
.password-notice {
  margin: 0 0 20px;
  padding: 0 0 40px;
  color: #878787;
  font-size: 15px;
  line-height: 22px;
  border-bottom: 1px solid #eee;
}

.v-input--switch__track.theme--light.error--text {
  color: rgba(0, 0, 0, 0.38) !important;
}
.v-input--selection-controls__ripple.error--text {
  color: #fff !important;
}
.v-input--switch__thumb.theme--light.error--text {
  color: #fafafa !important;
}

.error {
  display: block;
}
</style>
